"use client";

import { AuthProvider } from "@/context/AuthContext";
import { ValidatorProvider } from "@/context/ValidatorContext";

export default function AIValidatorLayout({
    children,
}: {
    children: React.ReactNode;
}) {
    return (
        <AuthProvider>
            <ValidatorProvider>
                {children}
            </ValidatorProvider>
        </AuthProvider>
    );
}
